import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { G_DRAG_AND_DROP__area_with_label } from '@/pages/page_generation/layouts/nodes/node/fields/image/_base/_drag_and_drop/G_DRAG_AND_DROP__area_with_label';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_image } from '@/state/ui/_base/LOCAL__ui_set_image';
import { assert_false } from '@shared/asserts/utils_asserts';
import { DragEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function DRAG_AND_DROP__image_compare__internal() {
  const dispatch = use_dispatch();

  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  const { drag_and_drop__image_internal_zones_show, drag_and_drop__image_internal_dragged, grid2d_image_compare__image_a } = use_slice_ui([
    'drag_and_drop__image_internal_zones_show',
    'drag_and_drop__image_internal_dragged',
    'grid2d_image_compare__image_a',
  ]);

  const is_image_with_similar_content_dragged = useMemo(() => get_is_image_with_similar_content_dragged(), [drag_and_drop__image_internal_dragged]);

  /*
   *
   */

  /*
   * EVENTS
   */

  function onDragOver(e: DragEvent) {
    e.preventDefault();
  }

  async function onDrop() {
    if (drag_and_drop__image_internal_dragged.is_stub()) return;

    if (!is_interactive()) return;

    assert_false(drag_and_drop__image_internal_dragged.is_stub());

    dispatch(LOCAL__ui_set_image({ key: 'grid2d_image_compare__image_a', value: drag_and_drop__image_internal_dragged }));
  }

  /*
   *
   */

  function get_class_name_opacity() {
    return drag_and_drop__image_internal_zones_show ? ' opacity-100 ' : ' opacity-0 ';
  }

  function is_interactive() {
    if (drag_and_drop__image_internal_dragged.is_stub()) return false;

    let out = true;

    if (!drag_and_drop__image_internal_zones_show) {
      out = false;
    } else if (is_image_with_similar_content_dragged) {
      out = false;
    }

    return out;
  }

  function get_text() {
    let out = '';

    if (drag_and_drop__image_internal_dragged.is_stub()) {
      out = 'No image to drop';
    } else if (is_image_with_similar_content_dragged) {
      out = 'Same Image is Already Here';
    } else {
      out = 'Drop Image Here';
    }

    return out;
  }

  function get_is_image_with_similar_content_dragged() {
    if (grid2d_image_compare__image_a.is_stub()) return false;
    if (drag_and_drop__image_internal_dragged.is_stub()) return false;

    let out = grid2d_image_compare__image_a.hash_sha256_content == drag_and_drop__image_internal_dragged.hash_sha256_content;

    return out;
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <div
      {...{ onDragOver, onDrop }}
      className={`absolute inset-0 flex-center 
        bg-black/80
        
    ${is_interactive() ? ' border border-2 border-dashed border-component-item-border  ' : ' pointer-events-none '}
    ${get_class_name_opacity()}
    
    `}
    >
      <G_DRAG_AND_DROP__area_with_label text={get_text()} class_name="bg-white/10" />
    </div>
  );
}
